import { render, staticRenderFns } from "./Scale_skip_question.vue?vue&type=template&id=3e0d60f9"
import script from "./Scale_skip_question.vue?vue&type=script&lang=js"
export * from "./Scale_skip_question.vue?vue&type=script&lang=js"
import style0 from "./Scale_skip_question.vue?vue&type=style&index=0&id=3e0d60f9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports